var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSvg29(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3473_16195)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66659 1.49967C5.66659 1.13148 5.36811 0.833008 4.99992 0.833008C4.63173 0.833008 4.33325 1.13148 4.33325 1.49967V4.83301H0.999919C0.631729 4.83301 0.333252 5.13149 0.333252 5.49967C0.333252 5.86786 0.631729 6.16634 0.999919 6.16634H4.33325V9.49967C4.33325 9.86787 4.63173 10.1663 4.99992 10.1663C5.36811 10.1663 5.66659 9.86787 5.66659 9.49967V6.16634H8.99992C9.36812 6.16634 9.66659 5.86786 9.66659 5.49967C9.66659 5.13149 9.36812 4.83301 8.99992 4.83301H5.66659V1.49967Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3473_16195"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 9.33333,
    height: 9.33333,
    fill: "white",
    transform: "translate(0.333252 0.833008)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg29);
export default __webpack_public_path__ + "static/media/svg29.099155770bafa0b5aa9f33ea0b66c9a2.svg";
export { ForwardRef as ReactComponent };